import React from 'react';
import StatusIcon from '@/components/StatusIcon/StatusIcon';
import { accessEventHelpers } from '@/utils/helpers';
import moment from 'moment';

const AccessEventStatusLabel = ({ accessEvent, trackBySupporter, ...props }) => {
  return (
    <div>
      <StatusIcon accessEvent={accessEvent} useMemberLabels={!trackBySupporter} />
      {accessEventHelpers.utilizationQuestionAnswered(accessEvent) && <span> &ndash; {moment(accessEvent.updated_at).format('MMM D, YYYY')}</span>}
    </div>
  );
};

export default AccessEventStatusLabel;
